import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: 'input[trimOnBlur], textarea[trimOnBlur]', standalone: true })
export class TrimOnBlurDirective {
  private ngControl = inject(NgControl);

  @HostListener('blur')
  onBlur() {
    const control = this.ngControl.control;
    if (control && typeof control.value === 'string') {
      control.setValue(control.value.trim());
    }
  }
}
